import React from 'react';
import { useVideoTransition } from '../hooks/useVideoTransition';
import { motion } from 'framer-motion';

const MenuOverlay = ({ isOpen, onClose }) => {
    const { handleNavigate } = useVideoTransition();
    
    if (!isOpen) return null;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.5,
                staggerChildren: 0.1,
                when: "beforeChildren"
            },
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.5,
                staggerChildren: 0.1,
                staggerDirection: +1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 5 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            y: 5,
            transition: {
                duration: 0.3
            }
        }
    };
    
    const handleMenuItemClick = (to) => (e) => {
        e.preventDefault();
        //console.log(`[MenuOverlay] Menu item clicked: ${to}`);
        onClose();
        //console.log(`[MenuOverlay] Menu closed, now navigating to: ${to}`);
        
        // If navigating to home page, reset the overlay animation state
        if (to === '/') {
            sessionStorage.removeItem('animationCompleted');
            sessionStorage.removeItem('lastDisplayedCount');
            sessionStorage.setItem('overlayVisible', 'false');
        }
        
        // Dispatch route change event before navigation
        window.dispatchEvent(new CustomEvent('routeChange', { detail: { to } }));
        
        handleNavigate(to);
        //console.log(`[MenuOverlay] handleNavigate called for: ${to}`);
    };

    return (
        <motion.div 
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-40"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={onClose}
        >
            <div className="text-center">
                <motion.nav 
                    className="flex flex-col gap-2 md:gap-2 px-4"                >
                    <motion.div variants={itemVariants}>
                        <a 
                            href="/"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/')}
                        >
                            HOME
                        </a>
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <a 
                            href="/about"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/about')}
                        >
                            ABOUT
                        </a>
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <a 
                            href="/create-star"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/create-star')}
                        >
                            CREATE A STAR
                        </a>
                    </motion.div>

                    <motion.div variants={itemVariants}>
                        <a 
                            href="/find-star"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/find-star')}
                        >
                            FIND A STAR
                        </a>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <a 
                            href="/messages"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/messages')}
                        >
                            STILL LOVED STARS
                        </a>
                    </motion.div>
                    <motion.div variants={itemVariants}>
                        <a 
                            href="/support"
                            className="block font-bold text-5xl sm:text-6xl md:text-6xl lg:text-6xl text-transparent hover:text-glow-pink transition-[text-shadow, text-stroke] duration-1000 ease-expo-out text-stroke-glow-pink md:md-text-stroke-glow-pink hover:text-stroke-transparent hover:md:md-text-stroke-transparent" 
                            onClick={handleMenuItemClick('/support')}
                        >
                            SUPPORT

                        </a>
                    </motion.div>
                </motion.nav>
            </div>
        </motion.div>
    );
};

export default MenuOverlay;